import AddressFormatter from '@/core/directives/address.directive';
import { DateFormatter, DateTimeFormatter } from '@/core/directives/date.directive';
import keycloak from '@/core/helpers/keycloak.helper';
import { createApp } from 'vue';
import App from './App.vue';
import OutsideClickDirective from './core/directives/outside-click.directive';
import { initSentry } from './core/helpers/sentry.helper';
import router from './core/router';
import store from './core/store';
import i18n from './i18n';

const app = createApp(App);

initSentry(app, router);

app.use(keycloak);
app.use(i18n);
app.use(store);
app.use(router);

app.directive('address', AddressFormatter);
app.directive('date', DateFormatter);
app.directive('datetime', DateTimeFormatter);
app.directive('outside-click', OutsideClickDirective);

app.mount('#app');
